import React from "react";
import { Modal, Button } from "react-bootstrap";
import infomationIcon from "../../assets/icons/infomation_icon.svg";

interface ConfirmDialogProps {
    show: boolean;
    onClose: () => void;
    onConfirm: () => void;
    message: string | React.ReactNode; 
    type: "save" | "delete";
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    show,
    onClose,
    onConfirm,
    message,
    type,
}) => {
    return (
        <Modal
            enforceFocus={true}
            restoreFocus={true}
            animation={true}
            show={show}
            onHide={onClose}
            centered
            className="confirm-dialog"
            backdropClassName="modal-backdrop-nested"
            backdrop={true} 
        >
            <Modal.Header className="formula-modal-header" closeButton>
                <Modal.Title className="sm-title">
                <img
                    src={infomationIcon}
                    alt=""
                    style={{ order: 0 }}
                />
                <span style={{ order: 1 }}>確認</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="formula-confirm-dialog_body">
                <p>{message}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="outline-primary bg-white modal-formula-cancel edit-index_btn"
                    size="sm"
                    onClick={onClose}
                >
                    キャンセル
                </Button>
                <Button
                    variant={type === "delete" ? "danger" : "primary"}
                    size="sm"
                    onClick={onConfirm}
                    className="modal-formula-save dialog-confirm-btn"
                >
                    {type === "delete" ? "削除" : "変更"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmDialog;
